import { EMPTY_OBJECT } from '../../../constants/common'
import { ScrollContainer } from '../../ScrollContainer'
import { SelectDropdown } from '../../Select'

import * as styles from './SearchDropdown.module.css'

/**
 * @import {ScrollContainerProps} from '../../ScrollContainer/ScrollContainer'
 */

/**
 * @typedef {object} SearchDropdownProps
 *
 * @property {React.ComponentType<ScrollContainerProps>} [Children]
 *
 * @property {React.ReactNode} [children]
 *
 * @property {ScrollContainerProps} [childrenProps]
 *
 * @property {string} [className]
 */

/**
 * @param {SearchDropdownProps} props
 */
function SearchDropdown({
  Children = ScrollContainer,
  children,
  childrenProps: {
    className: childrenClassName = styles.children,
    ...childrenProps
  } = EMPTY_OBJECT,
  className = styles.SearchDropdown,
}) {
  return (
    <SelectDropdown className={className}>
      <Children {...childrenProps} className={childrenClassName}>
        {children}
      </Children>
    </SelectDropdown>
  )
}

export default SearchDropdown
